import { render } from "./Split.vue?vue&type=template&id=c91f77dc&scoped=true"
import script from "./Split.vue?vue&type=script&lang=js"
export * from "./Split.vue?vue&type=script&lang=js"

import "./Split.vue?vue&type=style&index=0&id=c91f77dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c91f77dc"

export default script